// extracted by mini-css-extract-plugin
export default {"container":"BKEDV","button":"Xglip","icon":"_0wacl","text":"Wmfyf","title":"NtyJR","info":"_4y0jM"};